module.exports = __webpack_public_path__ + "img/16581254_L.df48c1d2.png";